<template>
  <div class="courseware-wrapper">
    <a-spin v-if="loading" class="loading" tip="课件加载中..." size="large" />
    <div v-if="errMsg" class="error">
      <div class="error-content">
        <img src="@/static/images/null/null-7.png" />
        <p style="margin-bottom: 140px;">
          {{ errMsg }}
        </p>
      </div>
    </div>
    <CoursewarePlayer
      v-if="!loading&&!errMsg"
      :uuid="cwUuid"
      :data="cwData"
      @playerMessage="onPlayerMessage"
    />
  </div>
</template>
<script>
import { ref, reactive, watchEffect } from '@vue/composition-api'
import CoursewarePlayer from './Player.vue'
import service from '@/service/courseware'

const cwState = {
  NO_DATA: 0,
  DOING: 1,
  FAIL: 2,
  SUCCESS: 3
}

export default {
  components: {
    CoursewarePlayer
  },
  props: {
    classTypeId: Number,
    lessonId: Number
  },
  setup(props) {
    const loading = ref(true)
    const errMsg = ref('')
    const cwUuid = ref('')
    const cwData = reactive({})

    watchEffect(async () => {
      try {
        const res = await service.getLessonCourseware(props.classTypeId, props.lessonId)
        loading.value = false
        if (res.state === cwState.SUCCESS) {
          errMsg.value = ''
          cwUuid.value = res.uuid
          cwData.type = res.type || 'slide';
          ['cwSign', 'cwPf', 'cwExpired', 'cwUser'].forEach(key => { cwData[key] = res[key] })
        } else {
          errMsg.value = `内容更新中，敬请期待~`
        }
      } catch (e) {
        loading.value = false
        errMsg.value = '获取课件异常'
      }
    })

    const onPlayerMessage = evt => {
      // console.log(evt)
    }

    return {
      loading,
      errMsg,
      cwUuid,
      cwData,
      onPlayerMessage
    }
  }
}
</script>
<style lang="less" scoped>
.courseware-wrapper {
  height: 100%;
  position: relative;

  .loading {
    width: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .error {
    background-color: #F0F2F4;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .error-content {
      img {
        width: 350px;
        height: 245px;
      }
      p {
        text-align: center;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #70788C;
      }
    }
  }
}
</style>
